import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { NavIcon } from '../../svgs/icons/NavIcon';
import { styleSheet } from './styles';

export interface INavBarLinkBase {
	icon?: React.ReactNode | ((isActive: boolean) => React.ReactNode);
	linkName?: string;
	/** Accepts either a path as a string or a list of paths as strings the first one will be used as the link path */
	path?: string | string[];
}

export interface INavBarLink extends INavBarLinkBase {
	accessory?: JSX.Element;
	className?: string;
	compactLayout?: boolean;
	onLinkClick?(e: React.MouseEvent<HTMLElement>): void;
	activeLinkStyles: StyleDeclarationValue[];
	linkStyles: StyleDeclarationValue[];
}

export function NavBarLink({
	accessory,
	compactLayout,
	onLinkClick,
	linkName,
	path,
	icon,
	activeLinkStyles,
	linkStyles,
}: INavBarLink) {
	const location = useLocation();
	const [isMouseOver, setIsMouseOver] = React.useState(false);

	const getActiveStatus = (paths: string | string[], pathname: string): boolean => {
		const isActivePath = (pathToCheck: string) => {
			const p = pathToCheck.split(`?`)[0];
			return new RegExp(`^${p}`).test(pathname);
		};
		return typeof paths === 'object' ? paths.some(x => isActivePath(x)) : isActivePath(paths);
	};

	const isRouteActive = getActiveStatus(path, location.pathname);
	const isActive = isMouseOver || isRouteActive;
	const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		if (onLinkClick) {
			onLinkClick(e);
		}
	};
	return (
		<NavLink
			isActive={(_match, _location) => {
				return getActiveStatus(path, _location.pathname);
			}}
			activeClassName={`${css(...activeLinkStyles)}`}
			className={`${css(...linkStyles)}`}
			location={location}
			onClick={handleLinkClick}
			onMouseEnter={() => setIsMouseOver(true)}
			onMouseLeave={() => setIsMouseOver(false)}
			title={linkName ? linkName : undefined}
			to={typeof path === 'object' ? path[0] : path}
		>
			{!!linkName && (
				<div className={css(styleSheet.icon)}>
					{icon ? (
						typeof icon === 'function' ? (
							icon(isActive)
						) : (
							icon
						)
					) : (
						<NavIcon isActive={isActive} iconName={linkName} fillColor='white' />
					)}
				</div>
			)}
			{!compactLayout && <span className={css(styleSheet.linkName)}>{linkName}</span>}
			{!!accessory && <div className={css(compactLayout ? styleSheet.compactFlag : styleSheet.flag)}>{accessory}</div>}
		</NavLink>
	);
}
